// extracted by mini-css-extract-plugin
export default {"container":"InvoiceSearchLoading_container__jrv1u"};